import * as types from "./mutation_types";

export default {
  [types.SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.SET_LICENSES](state, data) {
    Object.assign(state, {
      error: "",
      licenses: data,
    });
  },

  [types.TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
